module.exports = __webpack_public_path__ + "static/media/HAPI FHIR.277d5a54.png";